module.exports = __webpack_public_path__ + "images/tft-hero-mobile-bg.webp";